'use strict';

var GridNdReoptPreviewButtonDirective = function GridNdReoptPreviewButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-nd-reopt-preview-button.html'),
    controller: 'GridNdReoptPreviewButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
        $scope.onRowSelection(selectedRows, selectedRowIndexes);
      });
    }
  };
};
GridNdReoptPreviewButtonDirective.$inject = [];
module.exports = GridNdReoptPreviewButtonDirective;